export default __webpack_public_path__ + "static/media/argentan7.0ab6f5e0.jpg";